// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wcbP","selected":"styles_selected__1oLNA"};